<template>
  <videoCheckDialog
    ref="videoCheckDialog"
    title="检测"
    :is-show-footer="true"
    width="700px"
    icon="icon-cy-idxDeail"
    @dialogSure="dialogSure"
  >
    <div class="check-dimension">
      <div
        class="checked-list"
        v-if="isShowCheckList"
      >
        <div
          class="item"
          v-for="(item, index) in listData"
          :key="index"
        >
          <div class="item-image">
            <el-image
              fit="cover"
              :src="type === 'audio' ? audioBg : item.attachments[0].s_uri"
            />
            <span
              class="item-actions"
              @click="removeCheck(item)"
            >移除文件</span>
          </div>
          <h6 :title="item.attachments[0].name">
            {{ item.attachments[0].name }}
          </h6>
        </div>
      </div>
      <div class="check-dimension-title">
        <span>智能审核</span>
        <el-checkbox
          :disabled="true"
          v-model="checkAllSafeList"
        />
      </div>
      <div class="video-content">
        <div
          v-for="(item, index) in safeList"
          :key="index"
          class="video-content-check checked"
        >
          {{ safeMap[item] }}
        </div>
      </div>
    </div>
    <div class="check-dimension-title check-intelligent">
      <span>智能识别</span>
      <el-checkbox
        :disabled="true"
        v-model="checkAllTagList"
      />
    </div>
    <div class="video-content">
      <div
        v-for="(item, index) in tagList"
        :key="index"
        class="video-content-check checked"
      >
        {{ tagMap[item] }}
      </div>
    </div>
    <div
      class="check-dimension"
      v-if="isShowVoiceReco"
    >
      <el-checkbox
        v-model="openSummary"
        :disabled="true"
      >
        语音识别完成后智能提取摘要
      </el-checkbox>
    </div>
  </videoCheckDialog>
</template>
<script>
import videoCheckDialog from '@components/dialog/cyDialogCommon'
export default {
  name: 'CheckDialog',
  props: {
    checkedList: {
      type: Array,
      default: () => []
    },
    // 是否展示检测列表
    isShowCheckList: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'video'
    }
  },
  data() {
    return {
      listData: [],
      audioBg: require('@assets/imgs/jlxk/audio-bg.png'),
      safeMap: {
        porn: '色情识别',
        terrorism: '暴恐涉政',
        ad: '广告识别',
        live: '不良场景',
        antispam: '语音反垃圾检测'
      },
      tagMap: {
        tag: '视频标签',
        face: '人物识别',
        txt: '语音识别',
        ocr: '文字识别'
      },
      checkAllSafeList: true,
      checkAllTagList: true,
      openSummary: true
    }
  },
  computed: {
    isVideoDetection() {
      return this.type === 'video'
    },
    isImgDetection() {
      return this.type === 'img'
    },
    isShowVoiceReco() {
      return !this.isImgDetection
    },
    // 智能审核列表
    safeList() {
      return this.isVideoDetection
        ? ['porn', 'terrorism', 'ad', 'live']
        : this.isImgDetection
          ? [
            'porn',
            'terrorism',
            'nausea',
            'ad',
            'politics',
            'imageText',
            'live',
            'violate'
          ]
          : ['antispam']
    },
    // 智能识别列表
    tagList() {
      return this.isVideoDetection
        ? ['tag', 'face', 'txt', 'ocr']
        : this.isImgDetection
          ? ['tag', 'face']
          : ['txt']
    },
    detectionAttach() {
      return this.isImgDetection && this.listData.length !== 0
        ? this.listData.map(item => {
          return {
            o_uri: item.attachments[0].o_uri,
            id: item.attachments[0].id
          }
        })
        : []
    }
  },
  components: {
    videoCheckDialog
  },
  methods: {
    initParams() {},
    removeCheck(value) {
      this.listData = this.listData.filter(
        item => JSON.stringify(item) !== JSON.stringify(value)
      )
    },
    dialogSure() {
      if (this.listData.length === 0) {
        this.$refs.videoCheckDialog.cyDialogCommon = false
        return false
      }
      let txtIndex = this.tagList.indexOf('txt')
      let params = {}
      if (this.isImgDetection) {
        params = {
          docId: this.checkedList[0].id,
          attachments: this.detectionAttach,
          checkItems: ['tag', 'check', 'face']
        }
      } else {
        params = {
          checkItems: this.listData,
          type: this.type,
          checkParam: {
            'scenes-txt': txtIndex !== -1 ? 'txt' : '',
            'scenes-safe': this.safeList,
            openSummary: this.openSummary
          }
        }
        if (this.isVideoDetection) {
          params.checkParam['scenes-tag'] = this.tagList.filter(
            item => item !== 'txt'
          )
        }
      }
      this.$emit('handleVideoCheck', params)
      this.$refs.videoCheckDialog.cyDialogCommon = false
    },
    initData() {
      this.listData = []
      if (!this.checkedList || this.checkedList.length === 0) return false
      this.checkedList.forEach(item => {
        item.attachments.forEach(sub => {
          this.listData.push({ docId: item.id, attachments: [sub] })
        })
      })
    }
  },
  watch: {
    checkedList: {
      handler() {
        this.initData()
      },
      immediate: true,
      deep: true
    },
    type: {
      handler(newVal) {
        if (newVal === 'img') {
          this.tagMap['tag'] = '图像标签'
          this.safeMap = {
            porn: '涉黄审核',
            terrorism: '暴恐审核',
            nausea: '恶心图审核',
            ad: '广告审核',
            politics: '涉政审核',
            imageText: '图文审核',
            live: '不良场景涉黄',
            violate: '违禁图库审核'
          }
        } else {
          this.tagMap['tag'] = '视频标签'
          this.safeMap = {
            porn: '色情识别',
            terrorism: '暴恐涉政',
            ad: '广告识别',
            live: '不良场景',
            antispam: '语音反垃圾检测'
          }
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog.cy-dialog-common {
  .el-dialog__header {
    border-bottom: 1px solid #e8e8e8;
  }
  .el-dialog__body {
    padding: 10px 44px 15px;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
    .el-checkbox {
      &__inner {
        cursor: initial;
        background-color: #4497ec;
        &:after {
          cursor: initial;
          border-color: #ffffff;
        }
      }
      &__label {
        color: #4497ec;
        cursor: initial;
      }
    }
    .check-dimension {
      margin-top: 15px;
      .checked-list {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .item {
          position: relative;
          width: 140px;
          margin-right: 15px;
          text-align: center;
          &:nth-child(4n) {
            margin: 0;
          }
          .item-image {
            &:hover {
              span.item-actions {
                opacity: 1;
              }
            }
          }
          .el-image {
            width: 100%;
            height: 90px;
            border-radius: 5px;
            &__inner {
              width: 100%;
              height: 100%;
              border-radius: 5px;
            }
          }
          h6 {
            margin: 9px 0;
            @extend .ellipsis;
            font-size: 14px;
            color: #333;
          }
          &-actions {
            position: absolute;
            width: 100%;
            height: 90px;
            left: 0;
            top: 0;
            cursor: default;
            text-align: center;
            color: #fff;
            opacity: 0;
            cursor: pointer;
            font-size: 20px;
            border-radius: 5px;
            line-height: 90px;
            color: #fff;
            font-size: 14px;
            background-color: rgba(0, 0, 0, 0.5);
            transition: opacity 0.3s;
          }
        }
      }
    }
    .check-dimension-title {
      display: flex;
      align-items: center;
      .el-checkbox {
        margin: 0 0 0 5px;
        font-size: 0;
      }
      &.check-intelligent {
        margin: 15px 0 0 0;
      }
    }
    .video-content {
      display: flex;
      flex-wrap: wrap;
      .video-content-check {
        height: 30px;
        padding: 0 13px;
        border-radius: 5px;
        margin: 10px 18px 0 0px;
        height: 30px;
        border: 1px solid rgba(228, 228, 228, 1);
        line-height: 30px;
        font-size: 13px;
        text-align: center;
        // cursor: pointer;
        &.checked {
          border-color: #4497ec;
          background-image: url(~@/assets/icons/jlxk-detection-checked.png);
          background-repeat: no-repeat;
          background-position: right bottom;
        }
      }
    }
  }
  .el-dialog__footer {
    margin: 0;
  }
}
</style>
